import bujar from '../../img/staff/bujar.png'
import berat from '../../img/staff/berat.png'
import abdyl from '../../img/staff/abdyl.png'
import amir from '../../img/staff/amir.png'

const staff = [
  {
    name: 'Bujar Prishtina',
    title: 'CEO',
    img: bujar,
  },
  {
    name: 'Berat Prishtina',
    title: 'Sales',
    img: berat,
  },
  {
    name: 'Abdyl Prishtina',
    title: 'Marketing',
    img: abdyl,
  },
  {
    name: 'Amir Prishtina',
    title: 'Marketing Assistant',
    img: amir,
  },
]

export default staff
